import { SelectOption } from '@navstation-portal/shared/data-model/common';

export enum FieldType {
  Calendar = 'Calendar',
  Select = 'Select',
  Number = 'Number',
  Position = 'Position',
  Text = 'Text',
  Toggle = 'Toggle',
  Checkbox = 'Checkbox',
}

export interface FormFieldConfigBase {
  fieldLabel: string;
  fieldId: string;
  fieldDescription?: string;
  isRequired?: boolean;
  isReadOnly?: boolean;
  isVisible?: boolean;
  conditions?: FormFieldCondition[];
  calculated?: boolean;
}

export interface FormFieldCondition {
  when: string;
  is: boolean;
  action: FormFieldConditionAction;
  value: boolean;
}

export type FormFieldConditionAction = 'setEnabled' | 'setRequired';

export interface CalendarFieldConfig extends FormFieldConfigBase {
  fieldType: FieldType.Calendar;
}

export interface PositionFieldConfig extends FormFieldConfigBase {
  fieldType: FieldType.Position;
}

export interface TextFieldConfig extends FormFieldConfigBase {
  fieldType: FieldType.Text;
}

export interface SelectFieldConfig extends FormFieldConfigBase {
  fieldType: FieldType.Select;
  fieldOptions: SelectOption[] | undefined;
}

export interface NumberFieldConfig extends FormFieldConfigBase {
  fieldType: FieldType.Number;
  fieldUnit: string | undefined;
  useNumberGrouping?: boolean | undefined;
}

export interface CheckboxFieldConfig extends FormFieldConfigBase {
  fieldType: FieldType.Checkbox;
}

export type FormFieldConfig =
  | TextFieldConfig
  | CalendarFieldConfig
  | SelectFieldConfig
  | NumberFieldConfig
  | PositionFieldConfig
  | CheckboxFieldConfig;

export type GroupedFormData = Record<string, FormFieldConfig[]>;
